import logger from "@airhelp/node-logger";
import type { LanguageCode } from "config/languages";
import type useExtendedRouter from "hooks/useExtendedRouter";
import type { ExperimentConfig, OptimizelyEvent, OptimizelyPushEvent } from "stores/OptimizelyStore";

const getOptimizely = () => {
  window.optimizely = window.optimizely || [];

  return window.optimizely;
};

export const pushOptimizelyConversionEvent = (event: OptimizelyPushEvent) => {
  getOptimizely().push(event);
};

export const getOptimizelyVariations = (callback: (event: OptimizelyEvent) => void) => {
  getOptimizely().push({
    type: "addListener",
    filter: {
      type: "lifecycle",
      name: "campaignDecided",
    },
    handler: callback,
  });
};

export const pushConversionEvent = (experimentConfig: ExperimentConfig) => {
  const { customEvent, experimentName, experimentId } = experimentConfig;
  return () =>
    customEvent
      ? pushOptimizelyConversionEvent(customEvent)
      : logger.warn(`No custom event defined for experiment: ${experimentName} experimentId: ${experimentId}`);
};

export const isSupportedUrl = (
  experimentConfig: ExperimentConfig,
  language: LanguageCode,
  extendedRouter: ReturnType<typeof useExtendedRouter>
) => {
  const { query, isHomepage } = extendedRouter;
  const querySlug = query?.slug?.[0] as string;

  return experimentConfig.pages.some(
    ({ language: experimentLanguage, slug: experimentSlug }) =>
      (experimentLanguage === language && typeof experimentSlug === "undefined") ||
      (querySlug === experimentSlug && experimentLanguage === language) ||
      (experimentSlug === "" && isHomepage && experimentLanguage === language)
  );
};
